export const SET_INPUT = "SET_INPUT";
export const TOGGLE_FORM = "TOGGLE_FORM"

export const setInput = input => {
  return {
    type: SET_INPUT,
    payload: input
  }
}

export const toggleForm = toggle => {
  return {
    type: TOGGLE_FORM,
    payload: toggle
  }
}
